import React from "react";

type Props = {
  className?: string;
  text?: string;
};
const PreloaderDots = (props: Props) => {
  const [dotCount, setDotCount] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((dotCount) => (dotCount === 3 ? 0 : dotCount + 1));
    }, 300);

    return () => {
      clearInterval(interval);
    };
  }, []);

  // note: we have to always render 3 dots to prevent width from changing
  return (
    <span className={props.className} style={{ display: "inline-block" }}>
      {props.text}
      {Array.from({ length: 3 }, (_, i) => (
        <span key={i} style={{ visibility: i < dotCount ? "visible" : "hidden" }}>
          .
        </span>
      ))}
    </span>
  );
};
export default PreloaderDots;
